import React from 'react';
import {MasterLayout} from 'components/layouts';
import {SendNeedofferForm} from 'components/send-needoffer';
import MemberZone from './MemberZone.jsx'
import title from 'constants/TitlePages.js';

class SendNeedoffer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.SendNeedoffer;
  }

  render() {
    return (
      <MasterLayout>
        <SendNeedofferForm/>
      </MasterLayout>
    );
  }
}

export default MemberZone(SendNeedoffer);



// WEBPACK FOOTER //
// ./pages/users/SendNeedoffer.jsx